<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">SMS MT Queue</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-card no-body>
			<b-card-header>
				<b-form @submit="submitSearch">
					<b-row class="justify-content-center">
						<b-col cols="auto">
							<label for="imsi" class="font-weight-900 text-sm">IMSI</label>
						</b-col>
						<b-col cols="4">
							<b-form-input
								id="imsi"
								v-model="imsi"
								placeholder="IMSI Numbers Only"
								type="number"
								:state="searchDisabled"
								size="sm"
								disabled-field="notEnabled"
							>
							</b-form-input>
							<b-form-invalid-feedback :state="searchDisabled">
								You can perform a search by a full or partial IMSI
							</b-form-invalid-feedback>
						</b-col>
						<b-col cols="auto">
							<label for="msisdn" class="font-weight-900 text-sm">MSISDN</label>
						</b-col>
						<b-col cols="4">
							<b-form-input
								id="msisdn"
								v-model="msisdn"
								placeholder="MSISDN Numbers Only"
								type="number"
								:state="searchDisabled"
								size="sm"
								disabled-field="notEnabled"
							>
							</b-form-input>
							<b-form-invalid-feedback :state="searchDisabled">
								You can perform a search by a full or partial MSISDN
							</b-form-invalid-feedback>
						</b-col>
						<b-col cols="auto">
							<b-button variant="primary" size="sm" type="submit" :disabled="!searchDisabled">
								Search <i class="fa fa-search"></i>
							</b-button>
						</b-col>
					</b-row>
				</b-form>
			</b-card-header>
			<b-card-body class="p-3">
				<div class="text-center w-100" v-if="loadingStatus">
					<b-icon icon="three-dots" class="text-center" animation="cylon" font-scale="4"></b-icon>
				</div>
				<div class="primary-table" v-if="!loadingStatus">
					<b-table
						:items="items"
						:fields="fields"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						:sort-direction="sortDirection"
						class="text-center custom-table"
						hover
						responsive
						show-empty
						small
						striped
					>
						<template #cell(debug)="row">
							<span
								v-if="showDebug.includes(row.index)"
								class="cursor-pointer"
								@click="setShowDebug(row.index)"
							>
								{{ row.value }}
							</span>
							<span v-else class="blur nowrap cursor-pointer" @click="setShowDebug(row.index)">
								{{ row.value.substring(0, 20) }}
							</span>
						</template>
						<template #empty="scope"> There are no records to show </template>
					</b-table>
				</div>

				<b-row class="mt-4" v-if="items.length > 0">
					<b-col> Showing {{ startPage() }} - {{ lastPage() }} of {{ totalRows }} entries </b-col>
					<b-col xl="auto" md="auto" sm="auto ">
						<b-pagination
							class="flex-fill-custom pr-4"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</b-card-body>
		</b-card>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import handleResponse from "../../../common/directive/handlResponse";
import initService from "../../../common/api-services/init-service";
import pagination from "../../../common/format/pagination";

export default {
	name: "sms-mt-queue",
	components: {
		RouteBreadCrumb,
	},
	mounted() {
		document.title = "Troubleshooting - SMS MT Queue";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
			items: [],
			fields: [
				{key: "idmt", label: "IDMT", sortable: true, sortDirection: "desc"},
				{key: "service_type", label: "Service Type", sortable: true, sortDirection: "desc"},
				{key: "source_address_ton", label: "Src Address TON", sortable: true, sortDirection: "desc"},
				{key: "source_address_npi", label: "Src Address NPI", sortable: true, sortDirection: "desc"},
				{key: "source_address", label: "Src Address", sortable: true, sortDirection: "desc"},
				{key: "destination_address", label: "Dest Address TON", sortable: true, sortDirection: "desc"},
				{key: "destination_address_ton", label: "Dest Address NPI", sortable: true, sortDirection: "desc"},
				{key: "destination_address_npi", label: "Dest Address", sortable: true, sortDirection: "desc"},
				{key: "esm_class", label: "ESM Class", sortable: true, sortDirection: "desc"},
				{key: "protocol_id", label: "Protocol ID", sortable: true, sortDirection: "desc"},
				{key: "priority_flag", label: "Priority Flag", sortable: true, sortDirection: "desc"},
				{key: "scheduled_delivery_time", label: "Scheduled Delivery", sortable: true, sortDirection: "desc"},
				{key: "validity_period", label: "Validity Period", sortable: true, sortDirection: "desc"},
				{key: "registered_delivery", label: "Registered Delivery", sortable: true, sortDirection: "desc"},
				{key: "data_coding", label: "Data Coding", sortable: true, sortDirection: "desc"},
				{key: "sm_default_message_id", label: "SM Default Msg. ID", sortable: true, sortDirection: "desc"},
				{key: "sm_length", label: "SM Length", sortable: true, sortDirection: "desc"},
				{key: "created", label: "Created", sortable: true, sortDirection: "desc"},
				{key: "attempt", label: "Attempt", sortable: true, sortDirection: "desc"},
				{key: "attempts", label: "Attempts", sortable: true, sortDirection: "desc"},
				{key: "msisdn", label: "MSISDN", sortable: true, sortDirection: "desc"},
				{key: "imsi", label: "IMSI (MSIN)", sortable: true, sortDirection: "desc"},
				{key: "message_id", label: "Message ID", sortable: true, sortDirection: "desc"},
				{key: "storage_mode", label: "Storage Mode", sortable: true, sortDirection: "desc"},
				{key: "error_code", label: "Error Code", sortable: true, sortDirection: "desc"},
				{key: "debug", label: "Debug", sortable: true, sortDirection: "desc"},
				{key: "activity", label: "Activity", sortable: true, sortDirection: "desc"},
				{key: "failed", label: "Failed", sortable: true, sortDirection: "desc"},
			],
			msisdn: "",
			imsi: "",
			results: {},
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			loadingStatus: false,
			showDebug: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			fromPage: 0,
			totalRows: 0,
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
		searchDisabled() {
			let imsiState = String(this.imsi).length >= 3 && String(this.imsi).length <= 15;
			let msisdnState = String(this.msisdn).length >= 3 && String(this.msisdn).length <= 11;
			return imsiState || msisdnState;
		},
	},
	methods: {
		setShowDebug(index) {
			if (this.showDebug.includes(index)) this.showDebug = this.showDebug.filter(item => item !== index);
			else {
				this.showDebug = [...this.showDebug, index];
			}
		},
		async submitSearch(event) {
			event.preventDefault();
			this.loadingStatus = true;
			this.showDebug = [];
			await troubleshootingService
				.getSmsMtQueue(this.imsi, this.msisdn)
				.then(response => {
					if (
						!String(response.message).toLowerCase().includes("fail") &&
						!String(response.message).toLowerCase().includes("error") &&
						!String(response.message).toLowerCase().includes("abort") &&
						!response.message.hasOwnProperty("error")
					) {
						this.items = response.message;
						this.totalRows = response.message.length;
					} else if (String(response.message).toLowerCase().includes("abort")) {
						this.items = [];
						// this.$toast.info("No records found");
						//this.items = ["No records found"];
					} else {
						this.items = [];
						//this.items = ["No records found"];
						// if (response.message.hasOwnProperty("details")) {
						// 	this.$toast.error(`ERROR - ${response.message.details}`);
						// } else {
						// 	this.$toast.error("Error fetching records");
						// }
					}
					this.loadingStatus = false;
					this.getTotalRows();
				})
				.catch(error => {
					this.items = [];
					console.log(error);
					this.loadingStatus = false;
					//let {type, msg} = handleResponse.apiResponse(error);
					//this.$toast(msg, {type: type});
				});
		},
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
			return pagination.startPageFunc(this.currentPage, this.perPage);
		},
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
		},
	},
};
</script>

<style scoped>
.blur {
	color: transparent;
	text-shadow: 0 0 8px #000;
}
</style>
